/*
 * Copyright © 2021 EPAM Systems, Inc. All Rights Reserved. All information contained herein is, and remains the
 * property of EPAM Systems, Inc. and/or its suppliers and is protected by international intellectual
 * property law. Dissemination of this information or reproduction of this material is strictly forbidden,
 * unless prior written permission is obtained from EPAM Systems, Inc
 */

import boliVSpineLogo from './assets/images/logo_bolivspine.png';
import kraviraLogo from './assets/images/logo_kravira.png';
import sizLogo from './assets/images/logo_siz.jpeg';
import sizNovaLogo from './assets/images/logo_siz_nova.png';
import grandmedica from './assets/images/logo_grandmedica.png';
import lubimydoctorLogo from './assets/images/logo_lubimydoctor.png';
import aclinicaLogo from './assets/images/logo_aclinica.png';
import babybossLogo from './assets/images/logo_babyboss.png';
import alfamedLogo from './assets/images/logo_alfamed.png';
import mdprcLogo from './assets/images/logo_mdprc.png';
import prdclLogo from './assets/images/logo_prdcl.png';
import amadeiLogo from './assets/images/logo_amadei.png';
import unimedLogo from './assets/images/logo_unimed.png';
import belsonoLogo from './assets/images/logo_belsono.png';
import anatomiyaLogo from './assets/images/logo_anatomiya.png';
import prfimdlLogo from './assets/images/logo_prfimdl.png';
import aksmitLogo from './assets/images/logo_aksmit.png';
import grvita from './assets/images/logo_grvita.png';
import g36i6 from './assets/images/logo_36i6.png';
import davinciLogo from './assets/images/logo_davinci.png';

import grantmdLogo from './assets/images/logo_grantmd.png';
import okomdsonLogo from './assets/images/logo_okmdson.png';

import bullfinchLogo from './assets/images/logo_bullfinch.png';
import martaLogo from './assets/images/logo_marta.png';
import dayscompLogo from './assets/images/logo_dayscomp.png';

import lifeCityLogo from './assets/images/logo_lifecity-minsk.png';
import vnukiLogo from './assets/images/logo_vnki.png';
import doctortutLogo from './assets/images/logo_doctortut.png';
import novolekarLogo from './assets/images/logo_novolekar.jpeg';
import sevenmedLogo from './assets/images/logo_sevenmed.png';

import neoLogo from './assets/images/logo_neo.png';
import womenhealthLogo from './assets/images/logo_womenhealth.png';
import aibolitLogo from './assets/images/logo_aibolit.png';
import tariLogo from './assets/images/logo_tari.png';
import garmonyaLogo from './assets/images/logo_garmonya.png';
import tmgrphLogo from './assets/images/logo_tmgrph.png';
import medplLogo from './assets/images/logo_medicplus.png';
import butterflyLogo from './assets/images/logo_butterfly.png';
import liniiLogo from './assets/images/logo_linii.jpg';
import Linii2Logo from './assets/images/logo_linii2.jpg';
import medartLogo from './assets/images/logo_medart.jpg';

import forestLogo from './assets/images/logo_forestmed-minsk.png';
import zdsnaLogo from './assets/images/logo_zdorovogosna-brest.png';
import visanmedLogo from './assets/images/logo_visanmed.png';
import genezLogo from './assets/images/logo_genez-mogilev.png';

import hrsontLogo from './assets/images/logo_horisont-new.png';

import KaskadLogo from './assets/images/kaskad-minsk_logo.png';
import GtfmirLogo from './assets/images/gtfmir-grodno_logo.png';
import MedstyleLogo from './assets/images/medstyle-minsk_logo.png';
import SupramedLogo from './assets/images/supramed-minsk_logo.png';

import ExpertLogo from './assets/images/expert-minsk_logo.png';
import MakoLogo from './assets/images/mako-borisov_logo.png';

import AstraLogo from './assets/images/logo_astra.png';
import MedikusLogo from './assets/images/logo_medikus-zhodino.png';

import GlazcovLogo from './assets/images/logo_glazcov.png';
import FibonacciLogo from './assets/images/logo_fibonacci.png';

import EclinicLogo from './assets/images/logo_eclinic.png';
import ZdorsnaMinskLogo from './assets/images/logo_zdorovogosna-minsk.png';

import PedLogo from './assets/images/logo_pediatria.png';
import ElicatoLogo from './assets/images/logo_elicato.jpg';
import FemineLogo from './assets/images/logo_femine.jpg';
import LuxsteticLogo from './assets/images/logo_luxestetic.jpg';
import AntesmedLogo from './assets/images/logo_antesmed.png';
import sportLabLogo from './assets/images/logo_sportlab.jpg';
import AdentLogo from './assets/images/logo_adent.jpg';
import LfkLogo from './assets/images/logo_lfkano-minsk.png';
import AclinicMsk from './assets/images/logo_aclinicmsk.jpg';
import EmiGomLogo from './assets/images/logo_amy.jpg';
import HomeopathyLogo from './assets/images/logo_homoeopathy.png';
import BiovinLogo from './assets/images/logo_biovin.jpg';
import SimedLogo from './assets/images/logo_simed-rechytsa.png';
import RestartLogo from './assets/images/logo_restart-minsk.png';
import EgodentLogo from './assets/images/logo_egodent.jpg';

import MaivamedLogo from './assets/images/logo_maivamed.png';

import AibolitLogo from './assets/images/logo-full.png';
import VokadLogo from './assets/images/logo_vokadent.png';
import GrantimedLogo from './assets/images/logo_grantimed.png';
import AnvimLogo from './assets/images/logo_anvimed.png';
import VirosalLogo from './assets/images/logo_virosal-minsk.jpg';
import EmaliyaLogo from './assets/images/logo_emaliya-mogilev.png';
import KsmluxLogo from './assets/images/logo_kosmomedlux-mogilev.png';

export const DOMAIN = 'aibolit.md';
export const DOC_DOMAIN = 'aibolit.by';
export const WEB_APP_URL = `https://webapp.aibolit.by`; // `https://aibolit.web.app`;
export const MMA_LINK = 'https://link.aibolit.md/l/mma';
export const clinicsData = {
    'boli-v-spine': {
        baseUrl: `https://bolivspine2.mis.${DOMAIN}/aimd-mis-server/api/online`,
        logo: boliVSpineLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    kravira: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/kravira-minsk`,
        logo: kraviraLogo,
        serviceBooking: true,
        allowDeepLink: false,
        allowMmaLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        linkToBumba: 'https://kravira.by/',
        consentsEnabled: true,
        mcName: 'МЦ Кравира',
    },
    sizg: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/semyazdorovie-gomel`,
        logo: sizLogo,
        serviceBooking: false,
        allowMmaLink: true,
        allowDeepLink: false,
        allowDoctorBookmark: true,
        downloadPdf: true,
        allowLinkToBumba: false,
        mcName: 'ОДО «Семья и здоровье»',
        consentsEnabled: true,
    },
    sizgn: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/semyazdorovie-gomel`,
        logo: sizNovaLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        mcName: 'ОДО «Семья и здоровье»',
        consentsEnabled: true,
    },
    grandmedica: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/grandmedica-minsk`,
        logo: grandmedica,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
    },
    lubdm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/lubimydoctor-minsk`,
        logo: lubimydoctorLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «ЛЮБИМЫЙ ДОКТОР»',
    },
    aclnm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/aclinica-mogilev`,
        logo: aclinicaLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: false,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        linkToBumba: 'https://www.aclinica.by/',
        consentsEnabled: true,
        mcName: 'МЦ А-Клиника',
    },
    adent: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/aclinica-mogilev`,
        logo: AdentLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: false,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        linkToBumba: 'https://www.aclinica.by/',
        consentsEnabled: true,
        mcName: 'МЦ А-Клиника',
    },
    bbssm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/babyboss-minsk`,
        logo: babybossLogo,
        serviceBooking: false,
        allowDeepLink: false,
        allowMmaLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        linkToBumba: 'https://babyboss.by/',
        consentsEnabled: true,
        mcName: 'МЦ «Baby Boss»',
    },
    amedm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/alphamed-minsk`,
        logo: alfamedLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    mdprc: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/medpractika-minsk`,
        logo: mdprcLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Мед-Практика»',
    },
    prdcl: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/proudclinic-minsk`,
        logo: prdclLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'МЦ «Proud Clinic»',
        consentsEnabled: true,
    },
    amadei: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/amadei-gomel`,
        logo: amadeiLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        consentsEnabled: true,
        mcName: 'МЦ «Амадей Клиник»',
    },
    unimed: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/unimed-borisov`,
        logo: unimedLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        consentsEnabled: true,
        mcName: 'МЦ «Юнимед»',

    },
    belsono: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/belsono-belarus`,
        logo: belsonoLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «БЕЛСОНО»',
    },
    antomia: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/anatomiya-minsk`,
        logo: anatomiyaLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'ЧТУП «Дэйскомп»',
        consentsEnabled: true,
    },
    bllfnch: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/anatomiya-minsk`,
        logo: bullfinchLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'ЧТУП «Дэйскомп»',
        consentsEnabled: true,
    },
    marta: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/anatomiya-minsk`,
        logo: martaLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'ЧТУП «Дэйскомп»',
        consentsEnabled: true,
    },
    dscomp: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/anatomiya-minsk`,
        logo: dayscompLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'ЧТУП «Дэйскомп»',
        consentsEnabled: true,
    },
    prfimdl: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/profimed-lida`,
        logo: prfimdlLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «Профимед»',
    },
    prfimdm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/profimed-lida`,
        logo: prfimdlLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «Профимед»',
    },
    prfimda: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/profimed-lida`,
        logo: AstraLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «Профимед»',
    },
    aksmitm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/aksamit-minsk`,
        logo: aksmitLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Аксамит»',
    },
    grvitam: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/gravita-minsk`,
        logo: grvita,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Gravita Family Clinic»',
    },
    g36i6m: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/gravita-minsk`,
        logo: g36i6,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Gravita Family Clinic»',
    },
    okmdson: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/grantimed-okomedson-minsk`,
        logo: GrantimedLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Грантимед»',
    },
    grntmd: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/grantimed-okomedson-minsk`,
        logo: grantmdLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Грантимед»',
    },
    vinci: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/vinci-minsk`,
        logo: davinciLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    lifec: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/lifecity-minsk`,
        logo: lifeCityLogo,
        serviceBooking: true,
        allowDeepLink: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        downloadPdf: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'ООО «ЛайфСитиМед»',
    },
    vnkim: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/vnuki-minsk`,
        logo: vnukiLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    sevmed: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/sevenmed-gomel`,
        logo: sevenmedLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Семёрка»',
    },
    dtut: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/doctortut-minsk`,
        logo: doctortutLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        allowMmaLink: false,
        linkToBumba: 'https://doctortut.by/',
        consentsEnabled: true,
        mcName: 'Центр семейной медицины «Доктор ТУТ»',
    },
    nlekar: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/novolekar-minsk`,
        logo: novolekarLogo,
        serviceBooking: true,
        allowDeepLink: false,
        allowMmaLink: true,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'МЦ «Новый Лекарь»',
    },
    smneo: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/sportmedneo-minsk`,
        logo: neoLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'Центр спортивной реабилитации «Нео»',
    },
    whealth: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/womenhealth-grodno`,
        logo: womenhealthLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Моя клиника»',
    },
    eleos: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/eleos-minsk`,
        logo: aibolitLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    tarib: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/tari-bobruysk`,
        logo: tariLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    garmonya: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/garmonya-belarus`,
        logo: garmonyaLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'МЦ «Гармония»',
        consentsEnabled: true,
    },
    tmgrphm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/tomography-minsk`,
        logo: tmgrphLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        allowMmaLink: false,
        linkToBumba: 'https://mrt.by/',
        consentsEnabled: true,
        mcName: 'МЦ Томография',
    },
    medicp: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/medicplus-minsk`,
        logo: medplLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «МЕДИК Плюс»',
    },
    bttrfly: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/butterfly-minsk`,
        logo: liniiLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'LINII «Зеленый луг»',
    },
    linii2: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/lini-minsk`,
        logo: Linii2Logo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'LINII «Малиновка»',
    },
    medart: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/medart-minsk`,
        logo: medartLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «МедАрт»',
    },
    forstm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/forestmed-minsk`,
        logo: forestLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «Медицинский центр Форестмед»',
    },
    zdorsnab: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/zdorovogosna-brest`,
        logo: visanmedLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'VisanMed',
    },
    zdorsnam: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/zdorovogosna2-minsk`,
        logo: ZdorsnaMinskLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Центр Здорового Сна»',
    },
    eclnc: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/eclinic-minsk`,
        logo: EclinicLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    genezm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/genez-mogilev`,
        logo: genezLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Генез»',
    },
    hrzont: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/horizont2-minsk`,
        logo: hrsontLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        allowMmaLink: false,
        linkToBumba: 'https://horizont-med.by/',
        consentsEnabled: true,
        mcName: 'МЦ «Горизонт»',
    },
    sprmedm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/supramed-minsk`,
        logo: SupramedLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «СУПРАМЕД»',
    },
    gtfmirg: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/gtfmir-grodno`,
        logo: GtfmirLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        mcName: 'МЦ «Мир Здоровья»',
        consentsEnabled: true,
    },
    medstylem: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/medstyle-minsk`,
        logo: MedstyleLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МедСтайл Клиник',
    },
    kaskadm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/kaskad-minsk`,
        logo: KaskadLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: true,
        allowMmaLink: false,
        linkToBumba: 'https://kaskadclinic.by/',
        consentsEnabled: true,
        mcName: 'МЦ «Клиника Каскад»',
    },
    expertm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/expert-minsk`,
        logo: ExpertLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    makoborv: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/mako-borisov`,
        logo: MakoLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    veanmarg: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/veanmar-grodno`,
        logo: AibolitLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ Веанмар',
    },
    mdkusz: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/medikus-zhodino`,
        logo: MedikusLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Медикус»',
    },
    glazkov: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/glazkov-minsk`,
        logo: GlazcovLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    glazfib: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/glazkov-minsk`,
        logo: FibonacciLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
    },
    pedm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/pediatria-minsk`,
        logo: PedLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Педиатр и Я»',
    },
    elctog: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/elicato-gomel`,
        logo: ElicatoLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'Центр гинекологии Elicato',
    },
    femine: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/femineclinic-minsk`,
        logo: FemineLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Femin(e)»',
    },
    luxstg: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/luxestetic-gomel`,
        logo: LuxsteticLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «Люкс Эстетик»',
    },
    antsmd: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/antesmed-minsk`,
        logo: AntesmedLogo,
        serviceBooking: false,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'МЦ «Антес Мед»',
    },
    sprtlb: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/sportlab-minsk`,
        logo: sportLabLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО «Спортлаб»',
    },
    lfkm: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/lfkano-minsk`,
        logo: LfkLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowLinkToBumba: false,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        consentsEnabled: true,
        mcName: 'ООО "Ренатус"',
    },
    acmsk: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/aclinic-minsk`,
        logo: AclinicMsk,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'A Clinic - Центр современной косметологии',
    },
    emigom: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/emiclinic-gomel`,
        logo: EmiGomLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'МЦ «ЭМИ»',
    },
    homepth: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/homoeopathy-minsk`,
        logo: HomeopathyLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
    },
    biovin: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/biovin-minsk`,
        logo: BiovinLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'ООО «Биологос»',
    },
    simed: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/simed-rechytsa`,
        logo: SimedLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'МЦ «Симед»',
    },
    maivamd: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/maivamed-vitebsk`,
        logo: MaivamedLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
    },
    restart: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/restart-minsk`,
        logo: RestartLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'МЦ «РеСтарт»',
    },
    egodent: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/egodent-minsk`,
        logo: EgodentLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'EGODENT Стоматология',
    },
    vokad: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/vokadent-minsk`,
        logo: VokadLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
    },
    anvim: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/anvimed-grodno`,
        logo: AnvimLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'МЦ «АНВИМЕД»',
    },
    virom: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/virosal-minsk`,
        logo: VirosalLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'КЛИНИКА ПРАЙМ',
    },
    emaliya: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/emaliya-mogilev`,
        logo: EmaliyaLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
    },
    ksmlux: {
        baseUrl: `https://pub2.${DOMAIN}/api/v2/public/booking/kosmomedlux-mogilev`,
        logo: KsmluxLogo,
        serviceBooking: true,
        allowDeepLink: false,
        downloadPdf: true,
        allowMmaLink: true,
        allowDoctorBookmark: true,
        allowLinkToBumba: false,
        consentsEnabled: true,
        mcName: 'МЦ «PLAZMA»',
    },
};
// function splitObjectByConditions(inputObject) {
//   const allowDeepLink_downloadPdf = [];
//   const secondList = [];

//   Object.keys(inputObject).forEach((nameKey) => {
//     const { baseUrl, allowDeepLink, downloadPdf } = inputObject[nameKey];
//     const nameCode = baseUrl.split('/').pop(); // Extracts "name_code" from the baseUrl
//     const resultString = `${nameKey}/${nameCode}`;

//     if (allowDeepLink === true && downloadPdf === true) {
//       allowDeepLink_downloadPdf.push(resultString);
//     } else {
//       secondList.push(resultString);
//     }
//   });

//   return { allowDeepLink_downloadPdf, secondList };
// }
// console.log(splitObjectByConditions(clinicsData));
